module.exports = __webpack_public_path__ + "media/images/appTitle-52201c869a7125b43b3ba8cc9447987d.png";